import type { TEventsColumns, TFacesColumns } from './types';
import { StepEventsFilters, StepFacesFilters } from './ui/steps';

export const stepByObjectType = {
  faces: StepFacesFilters,
  events: StepEventsFilters,
};

export const defaultsFacesColumns: TFacesColumns[] = ['face_id', 'user_data', 'external_id', 'create_time', 'avatar', 'event_id'];
export const allFacesColumns: TFacesColumns[] = [
  ...defaultsFacesColumns,
  'lists',
];

export const defaultsEventsColumns: TEventsColumns[] = [
  'event_id', 'create_time', 'end_time', 'source', 'handler_id',
  'face_id', 'external_id', 'user_data', 'age', 'gender', 'emotion', 'mask',
  'track_id', 'top_match', 'district', 'area', 'city', 'street', 'house_number', 'geo_position',
];
export const allEventsColumns: TEventsColumns[] = [
  ...defaultsEventsColumns,
  'tags', 'meta', 'face_detections', 'attach_result',
  'liveness', 'body_detections', 'upper_body', 'body_basic_attributes',
  'accessories', 'lower_body', 'match_result',
];
